import Chat from "@components/Chat/Chat";
import type { PortService } from "@services/port-services/types";
import { getMainVessel } from "../grid/utils";
import { usePortServicesFormStore } from "../store/usePortServicesForm.store";

interface MessagesProps {
  portServiceDetails: PortService;
}

const Messages = ({ portServiceDetails }: MessagesProps) => {
  const { setField, newChatMessage } = usePortServicesFormStore();
  const setNewMessage = (newValue: string) => {
    setField("newChatMessage", newValue);
  };

  const isChatDisabled =
    portServiceDetails.status === "CANCELLED" ||
    portServiceDetails.status === "COMPLETED" ||
    portServiceDetails.status === "CLOSED";

  const vesselCallId = getMainVessel(portServiceDetails.linkedVesselCalls)?.vesselCallId;

  return (
    <div>
      <Chat
        isDisabled={isChatDisabled}
        entityId={portServiceDetails.id}
        entityType="PORT_SERVICES"
        newMessage={newChatMessage}
        secondRelatedEntityId={vesselCallId}
        setNewMessage={setNewMessage}
      />
    </div>
  );
};

export default Messages;
